import React, { useState } from "react";
import "./AboutUsSec0.css";

export const AboutUsSec0 = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="aboutsec0 standard-padding">
      <div className="about-container">
        {/* Left section with text */}
        <div className="about-text">
          <h1 className="heading aboutsec0-heading">
            Knowledge. Strategy. Execution
          </h1>

          <p className="text">
            Blueberry DMC is a destination management company built for the
            travel trade. Headquartered in Dubai, with active operations across
            Qatar, Singapore, Malaysia, and key African destinations, including
            Kenya, Tanzania, Zimbabwe, and Uganda. Working exclusively on a B2B
            model.
          </p>

          <p className="text">
            We partner with travel agents to deliver on-ground coordination,
            supplier management, and end-to-end itinerary handling across
            multiple destinations.
            
            {/* Extended Part of 2nd Para */}
            {isExpanded && (
              <>
                {" "}Every booking is backed by confirmed services, trusted local
                partnerships, and continuous follow-ups ensuring seamless
                execution from arrival to departure.
              </>
            )}

            {/* IF NOT EXPANDED: Read More Button yahan dikhega */}
            {!isExpanded && (
              <button 
                type="button" 
                className="read-more-btn" 
                onClick={toggleReadMore}
              >
                ...Read More
              </button>
            )}
          </p>

          {/* IF EXPANDED: 3rd Para and Read Less Button at the VERY END */}
          {isExpanded && (
            <>
              <p className="text">
                Our focus is simple: clarity, consistency, and reliable delivery.
                We help travel partners run itineraries exactly as planned, and
                uphold the expectations they have set with their clients.
              </p>
              
              <button 
                type="button" 
                className="read-more-btn read-less-btn" 
                onClick={toggleReadMore}
              >
                Read Less
              </button>
            </>
          )}
        </div>

        {/* Right section with background image */}
        <div className="about-image">
          <div className="about-overlay"></div>
        </div>
      </div>
    </div>
  );
};